import { combineReducers } from "redux";
import { applicationSlice } from "./application";
import { authSlice } from "./auth";
import { loadingSlice } from "./loading";
import { messageSlice } from "./message";
import { themeSlice } from "./theme";
import { userSlice } from "./user";

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  loading: loadingSlice.reducer,
  user: userSlice.reducer,
  application: applicationSlice.reducer,
  message: messageSlice.reducer,
  theme: themeSlice.reducer,
});

export default rootReducer;
